/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').factory('DashboardScheduler_Resource', ["$resource", "$location",
    function ($resource, $location) {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/dashboardScheduler/:id', {}, {
            query: {method: 'GET', isArray: true},
            get: {method: 'GET'},
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('DashboardScheduler', ["DashboardScheduler_Resource", "DashboardSchedulerData",
    function (DashboardScheduler_Resource, DashboardSchedulerData) {
        var DashboardScheduler = function (resource, dashboardId) {
            this.id = null;
            this.surname = null;
            this.type = null;
            this.object = null;
            this.message = null;
            this.sendTo = [];
            this.dashboardId = null;
            this.isDeleted = false;
            this.version = null;
            this.dashboardId = dashboardId;

            if (resource !== undefined && resource !== null)
                this.setValues(resource);


            DashboardSchedulerData.add(this);
        };

        DashboardScheduler.prototype.setId = function (id) {
            if (!this.id)
                this.id = id;
        };

        DashboardScheduler.prototype.getId = function () {
            return this.id;
        };

        DashboardScheduler.prototype.setValues = function (resource) {
            this.id = resource.id;
            this.surname = resource.surname;
            this.type = resource.type;
            this.object = resource.object;
            this.message = resource.message;
            this.sendTo = resource.sendTo;
            this.isDeleted = resource.isDeleted;
            if (resource.version)
                this.version = resource.version;
        };

        DashboardScheduler.prototype.getObjectResource = function () {
            var newDashboardScheduler = new DashboardScheduler_Resource();

            newDashboardScheduler.id = this.id;
            newDashboardScheduler.surname = this.surname;
            newDashboardScheduler.type = this.type;
            newDashboardScheduler.object = this.object;
            newDashboardScheduler.message = this.message;
            newDashboardScheduler.dashboardId = this.dashboardId;
            newDashboardScheduler.sendTo = this.sendTo;
            newDashboardScheduler.isDeleted = this.isDeleted;
            newDashboardScheduler.version = this.version;

            return newDashboardScheduler;
        };

        return DashboardScheduler;
    }
]);

angular.module('FlexyBeautyApp.services').factory('DashboardSchedulerSrv', ["$log", "ServerSrv", "DashboardScheduler_Resource", "DashboardSchedulerData", "UserActionData", "DashboardScheduler", "DashboardData",
    function ($log, ServerSrv, DashboardScheduler_Resource, DashboardSchedulerData, UserActionData, DashboardScheduler, DashboardData) {
        var dashboardSchedulerSrv = {};

        dashboardSchedulerSrv.save = function (dashboardScheduler, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(dashboardSchedulerSrv.saveSync, dashboardScheduler, successFunction, errorFunction);
        };
        dashboardSchedulerSrv.saveSync = function (dashboardScheduler, successFunction, errorFunction) {
            //$timeout (function () {

            var dashboardSchedulerRes = dashboardScheduler.getObjectResource();
            dashboardSchedulerRes.$save({}, //no params
                function (data) {
                    try {
                        dashboardScheduler.setId(data.id);
                        if (!dashboardScheduler.version || (data.version && data.version > dashboardScheduler.version))
                            dashboardScheduler.version = data.version;
                        if (dashboardScheduler.dashboardId) {
                            let dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
                            if (dashboard.dashboardSchedulers.indexOf(dashboardScheduler) === -1) {
                                dashboard.dashboardSchedulers.push(dashboardScheduler);
                            }
                        }
                        if (successFunction !== undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        };

        dashboardSchedulerSrv.remove = function (dashboardScheduler, successFunction, errorFunction) {
            DashboardSchedulerData.remove(dashboardScheduler);
            ServerSrv.startSavingProcess(dashboardSchedulerSrv.removeSync, dashboardScheduler, successFunction, errorFunction);
        };
        dashboardSchedulerSrv.removeSync = function (dashboardScheduler, successFunction, errorFunction) {
            //$timeout (function () {

            if (dashboardScheduler) {
                var dashboardSchedulerRes = dashboardScheduler.getObjectResource();
                dashboardSchedulerRes.$remove({id: dashboardScheduler.getId()}, //no params
                    function (data) {
                        try {
                            if (dashboardScheduler.dashboardId) {
                                let dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
                                if (dashboard.dashboardSchedulers.indexOf(dashboardScheduler) !== -1) {
                                    dashboard.dashboardSchedulers.splice(dashboardScheduler, 1);
                                }
                            }
                            if (successFunction !== undefined)
                                successFunction(data);
                        } finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try {
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        } finally {
                            ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                        }
                    }
                );
            }

            //},2000)
        };

        dashboardSchedulerSrv.updateLocally = function (id, object) {
            var dashboardScheduler = DashboardSchedulerData.getById(id);
            if (dashboardScheduler != null) {
                dashboardScheduler.setValues(object);
            }
            return dashboardScheduler
        };

        dashboardSchedulerSrv.addLocally = function (id, object) {
            var dashboardScheduler = DashboardSchedulerData.getById(id);
            if (dashboardScheduler == null) {
                var dashboardScheduler = new DashboardScheduler(object, object.dashboardId);
                dashboardScheduler.id = id;

                var dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
                if (dashboard)
                    dashboard.addDashboardScheduler(dashboardScheduler);

            }
            return dashboardScheduler;
        };

        dashboardSchedulerSrv.removeLocally = function (id, object) {
            var dashboardScheduler = DashboardSchedulerData.getById(id);
            if (dashboardScheduler != null) {
                var dashboard = DashboardData.getById(dashboardScheduler.dashboardId);
                if (dashboard)
                    dashboard.removeDashboardScheduler(dashboardScheduler);
                DashboardSchedulerData.remove(dashboardScheduler);
            }

            return dashboardScheduler;
        };

        return dashboardSchedulerSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('DashboardSchedulerData', [
    function () {
        var dashboardSchedulerData =
            {
                dashboardSchedulerList: [], // dashboard scheduler list for the entire application
                deletedDashboardSchedulerList: [] // deleted dashboard scheduler list for the entire application
            };
        dashboardSchedulerData.getById = function (dashboardId) {
            for (var i = 0; i < this.dashboardSchedulerList.length; i++)
                if (this.dashboardSchedulerList[i].id == dashboardId)
                    return this.dashboardSchedulerList[i];
            return null;
        };
        dashboardSchedulerData.getByIndex = function (dashboardIndex) {
            if (dashboardIndex >= 0 && dashboardIndex < this.dashboardSchedulerList.length) {
                return this.dashboardSchedulerList[dashboardIndex];
            } else
                return null;
        };
        dashboardSchedulerData.getIndexOf = function (dashboardScheduler) {
            if (dashboardScheduler)
                return this.dashboardSchedulerList.indexOf(dashboardScheduler);
            return -1;
        };
        dashboardSchedulerData.add = function (dashboardScheduler) {
            if (!dashboardScheduler.isDeleted)
                this.dashboardSchedulerList.push(dashboardScheduler);
            else
                this.deletedDashboardSchedulerList.push(dashboardScheduler);
        };
        dashboardSchedulerData.remove = function (dashboardScheduler) //Soft Remove
        {
            if (dashboardScheduler && !dashboardScheduler.isDeleted) {
                var indexDashboardScheduler = this.dashboardSchedulerList.indexOf(dashboardScheduler);
                if (indexDashboardScheduler != -1) {
                    this.dashboardSchedulerList.splice(indexDashboardScheduler, 1);
                    this.deletedDashboardSchedulerList.push(dashboardScheduler);
                    dashboardScheduler.isDeleted = true;
                }
            }
        };
        dashboardSchedulerData.getDashboardSchedulerList = function () {
            return this.dashboardSchedulerList;
        };
        dashboardSchedulerData.clear = function () {
            this.dashboardSchedulerList = [];
            this.deletedDashboardSchedulerList = [];
        };


        return dashboardSchedulerData;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/DashboardScheduler.js